<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
			:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
			:stepper_warning="[]"
			:stepper_danger="[]"
			:completed="3"
			@click="(e) => { val.page = (e+2); $emit('next_page', val); }"
			:click_fnc="$localStorage.get('user').username.role==3"
			/>
		<multiSelectInput 
			:flds="$localStorage.get('degrees').data"
			label="گروه آموزشی"
			@input="(e) => { val.value.degrees = e; p_sav('degrees'); }"
			:value="val.value.degrees"
			leading="گروه آموزشی مورد نظر خود را از بین موارد زیر برای تدریس انتخاب کنید. در صورتیکه گروه آموزشی تدریس شما وجود ندارد از طریق منوی تماس با ما آنرا اعلام نمایید"
		/>
		<multiSelectInput
			:flds="category_data()" 
			:value="val.value.category" 
			@input="(e) => { val.value.category = e; p_sav('category'); }"
			label="موضوع تدریس یا تخصص" 
			leading="موضوع مورد نظر خود را برای تدریس از بین موارد زیر انتخاب کنید. در صورتیکه موضوع تدریس یا تخصص شما وجود ندارد از طریق منوی تماس با ما آن را اعلام نمایید."
		/>
		<div class="d-flex align-items-center  mt-3">
			<span>			
				نوع تدریس
			</span>
			<button type="button" class="btn btn-secondary" style="background: none;border: none;" data-toggle="tooltip" data-html="true" title="نوع تدریس مورد نظر خود را  از بین موارد تدریس آنلاین، تدریس در محل کاربر و تدریس در محل استاد انتخاب کنید.">
				<svg style="width: 18px;height: 18px;" fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="800px" height="800px" viewBox="0 0 416.979 416.979" xml:space="preserve"> <g> <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M208.554,334.794 c-11.028,0-19.968-8.939-19.968-19.968s8.939-19.969,19.968-19.969c11.028,0,19.968,8.939,19.968,19.969 C228.521,325.854,219.582,334.794,208.554,334.794z M241.018,214.566c-11.406,6.668-12.381,14.871-12.43,38.508 c-0.003,1.563-0.008,3.14-0.017,4.726c-0.071,11.172-9.147,20.18-20.304,20.18c-0.044,0-0.088,0-0.131,0 c-11.215-0.071-20.248-9.22-20.178-20.436c0.01-1.528,0.013-3.047,0.016-4.552c0.05-24.293,0.111-54.524,32.547-73.484 c26.026-15.214,29.306-25.208,26.254-38.322c-3.586-15.404-17.653-19.396-28.63-18.141c-3.686,0.423-22.069,3.456-22.069,21.642 c0,11.213-9.092,20.306-20.307,20.306c-11.215,0-20.306-9.093-20.306-20.306c0-32.574,23.87-58.065,58.048-61.989 c35.2-4.038,65.125,16.226,72.816,49.282C297.824,181.361,256.555,205.485,241.018,214.566z"/> </g> </svg>
			</button>
		</div>
		<label>
			<input 
				type="checkbox" 
				v-model="val.value.online_teaching"
				@change="() => { p_sav('online_teaching'); }"
			/>
			آنلاین
		</label><br>
		<label>
			<input 
				type="checkbox"
				v-model="val.value.in_person_teaching"
				@change="() => { p_sav('in_person_teaching'); }"
			/>
			تدریس در محل کاربر
		</label><br>
		<label>
			<input 
				type="checkbox"
				v-model="val.value.teaching_home"
				@change="() => { p_sav('teaching_home'); }"
			/>
			تدریس در محل استاد
		</label>
		<textareaInput 
			label="آدرس محل تدریس"
			:value="val.value.address"
			@blurinputTxtFunc="(e) => { val.value.address = e; p_sav('address') }" 
			v-if="val.value.teaching_home==true || val.value.teaching_home==1"
			leading="در صورت انتخاب تدریس در محل استاد آدرس کامل خود را نوشته و لوکیشن محل تدریس را به صورت کامل مشخص کنید. این بخش فقط برای تدریس در محل استاد الزامی می‌باشد."
		/>
		<div class="row mt-3">
			<div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 " >
				<mapComponent
				style="height: 150px;"
					:latlng="val.value.location"
					@lat_lngFunc="(e) => { val.value.location = e; p_sav('location') }"
					v-if="val.value.teaching_home==true || val.value.teaching_home==1" 
				/>
			</div>
			<div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 ">
				<file_cloud 
					label="بارگزاری تصاویر محل تدریس" 
					:error="false"
					:files="val.value.pic_location" 
					@chengeFile="(e) => { uploadTF('pic_location', e);  }"
					@removeFile="(e) => { val.value.pic_location = e;  p_sav('pic_location'); }"
					v-if="val.value.teaching_home==true || val.value.teaching_home==1"
					leading="چند تصویر از محل تدریس خود بارگزاری کرده تا برای کاربران علاوه بر آشنایی با محل تدریس شما، حس اعتماد ایجاد شود. این بخش فقط برای تدریس در محل استاد الزامی می‌باشد."
				/>
			</div>
		</div>

		<btn 
			class="pt-3 w-100" 
			textClass="w-100" 
			text="ذخیره نهایی"
			@clickMe="setPage();"
		/>
		<span v-if="$localStorage.get('user').username">
			<btn 
				type="danger"
				class="pt-3 w-100" 
				textClass="w-100" 
				text="ارسال پیامک"
				@clickMe="send_sms();"
				v-if="$localStorage.get('user').username.role=='3' && ($localStorage.get('user').username.access_level=='0' || $localStorage.get('user').username.access_level=='3')"
			/>
		</span>
		<p v-if="SMS" class="border border-15 p-3 mt-3">
			<b class="text-orange">
				آخرین پیام پشتیبانی:
				<span class="text-gray" style="font-size: 10px;">{{ SMS.date }}</span>
			</b>
			<span class="text-justify text-14"> 
				{{ SMS.text }}
			</span>
		</p>
	</div>
</template>

<script>
	import btn from "../../UI/button/btn.vue";
	import multiSelectInput from "../../UI/input/multiSelectInput.vue";
	import textareaInput from "../../UI/input/textareaInput.vue";
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import { indexFinder } from "../../assets/library/filter.js";
	import file_cloud from "../../UI/uploadFile/file_cloud.vue";
	import mapComponent from "../../UI/map/map.vue";
	import { success, error, loading, success_sm } from "../../assets/library/messege.js";

	export default {
		name: 'teaching_information',
		data(){
			return {
				indexFinder: indexFinder,
				success_sm: success_sm,
				error: error,
				success: success,
				loading: loading,
				SMS: null,
			}
		},
		components: {
			btn,
			textareaInput,
			multi_step_progress,
			multiSelectInput,
			file_cloud,
			mapComponent,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){
			this.val.value.online_teaching = this.check_set('online_teaching');
			this.val.value.in_person_teaching = this.check_set('in_person_teaching');
			this.val.value.teaching_home = this.check_set('teaching_home');
			this.get_sms();
		},
		methods:{
//********************************************** */
get_sms(THIS=this){
	window.$.post(window.baseurl + 'teachers/get_SMS', {
		token: THIS.$localStorage.get('user'), 
		id: (THIS.chechRole()) ? this.$localStorage.get("s_id_t") : this.$route.params.id,
		page: 3
	}, function (D) {
		THIS.SMS = D.data
	}, "json");
},
// *********************************************************************
chechRole(){
	let user = this.$localStorage.get('user');
	if(user == null){
		return true;
	}else if(user.username.role != 3){
		return true;
	}else{
		return false;
	}
},
//********************************************** */
	send_sms(THIS=this){
		this.$swal.fire({
			position: 'center',
			type: '',
			title: "ارسال پیامک",
			input: "textarea",
			allowOutsideClick: false,
			showCloseButton: true,
			showConfirmButton: true,
			confirmButtonText: "ارسال",
			confirmButtonClass:"btn btn-outline-success border w-50",
			showCancelButton: true,
			cancelButtonText: "بستن",
			cancelButtonClass:"btn btn-danger w-50",
		}).then((result) => {
			if (result.value) {
				THIS.send_smsF(result.value);
			}			
		})
	},
	//********************************************** */
	send_smsF(text, THIS=this){
		window.$.post(window.baseurl + 'teachers/SMS', {
			token: THIS.$localStorage.get('user'), 
			val : this.val, 
			text: text,
			page: 3
		}, function (D) {
			THIS.success(THIS, 'ارسال شد')
			THIS.get_sms();
	}, "json");
},
		//********************************************************** */
		check_set(fld){
			return (this.val.value[fld]==true || this.val.value[fld]==1 || this.val.value[fld]=='1')
		},
		//********************************************************** */
		arr_str_2_int(val){
			var v = val.split(',');
			var a = [];
			for (let i = 0; i < v.length; i++) {
				v[i] = parseInt(v[i]);
				if(v[i]>0){
					a.push(v[i]);
				}
			}
			return a;
		},
		//********************************************************** */
		setPage(){
			if(this.val.value.category=='' || this.val.value.degrees=='' || !(this.val.value.teaching_home || this.val.value.in_person_teaching || this.val.value.online_teaching)  || (this.val.value.teaching_home &&  (this.val.value.pic_location.length==0 || this.val.value.address=='0' || this.val.value.address=='' || this.val.value.address==null)) ){
				this.error(this);
			}else{
				this.val.page = 6;
			}
		},
			//********************************************************** */
			category_data(){
				let degrees = this.$localStorage.get('degrees').data;
				let category = [];
				for(let i=0; i<this.val.value.degrees.length; i++){
					let index = -1;
					index = this.indexFinder(degrees, this.val.value.degrees[i]);
					for(let j=0; j<degrees[index].category.length; j++ ){
						var new_category=true;
						for(let c=0; c<category.length; c++ ){
							if (category[c].id == degrees[index].category[j].id && new_category) {
								new_category =false;
							}
						}
						if (new_category) {
							category.push(degrees[index].category[j]);
						}
					}
				}
				return category;
			},
			//********************************************************** */
			p_sav(fild) {
				this.val.id = (this.val.id) ? this.val.id : this.val.value.id;
				let f = (fild == "category") ? 'cats' : fild;
				let v = this.val.value[fild];
				if(this.val.value[fild] == true){
					v = 1;
				} else if(this.val.value[fild] == false){
					v = 0;
				}
				if(fild=='category' || fild=='degrees'){
					v = this.val.value[fild].toString();
				}

				if(this.$localStorage.get('user')) {
					window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: f ,val: v, id: this.val.id, admin: this.$localStorage.get('user')}, function () {
					
					}, "json");
				} else {
					window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: f ,val: v, id: this.val.id}, function () {
					
					}, "json");
				}
				
			},
			
//********************************************** */
uploadTF(val, e, THIS = this) {
	// THIS.loading(THIS);
	var formData = new FormData();
	formData.append("file", e);
	formData.append("format", ["jpg", "jpeg", "png", "pdf"]);
	formData.append("idImg", "t_[DATE]_[RANDOM]");
	var xhttp = new XMLHttpRequest();
	xhttp.open("POST", window.upldurl, true);
	xhttp.onreadystatechange = function () {
		if (this.readyState == 4 && this.status == 200) {
			this.getVar = JSON.parse(this.responseText);
			if (this.getVar.response == 1) {
				let F = {
					fileName: this.getVar.filename,
					fileUpload: this.getVar.uploadFileName,
				};
				THIS.val.value[val].push(F);
				THIS.p_sav(val);
				THIS.success_sm(THIS);
			} else {
				THIS.error(THIS, "فرمت فایل باید jpg باشد");
			}
		}
	};
	xhttp.send(formData);
},
		}
	}
</script>
<style>
</style>